import React from 'react';
import { FadeIn } from './FadeIn';
export function Problem() {
  return <section className="py-20 bg-cream" data-id="element-126">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-127">
        <FadeIn data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown mb-16" data-id="element-129">
            El ciclo que te tiene atrapada
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-10" data-id="element-130">
          <FadeIn delay={0.1} data-id="element-131">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark h-full" data-id="element-132">
              <div className="w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mb-6" data-id="element-133">
                <svg className="w-6 h-6 text-terracotta" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-134">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-135" />
                </svg>
              </div>
              <p className="text-brown-light leading-relaxed" data-id="element-136">
                <strong className="text-brown font-medium block mb-2" data-id="element-137">
                  Alerta Constante
                </strong>
                La mayoría de las madres viven en un estado de alerta constante,
                saltando de una crisis a otra sin entender qué la provocó. Te
                sientes agotada porque tus estrategias de "antes" ya no
                funcionan hoy.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-138">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark h-full" data-id="element-139">
              <div className="w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mb-6" data-id="element-140">
                <svg className="w-6 h-6 text-terracotta" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-141">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-142" />
                </svg>
              </div>
              <p className="text-brown-light leading-relaxed" data-id="element-143">
                <strong className="text-brown font-medium block mb-2" data-id="element-144">
                  Tiempo Perdido
                </strong>
                Te culpas por perder la paciencia. Te frustra que los consejos
                de internet sean demasiado dulces o demasiado severos. Sientes
                que el tiempo vuela y, en lugar de disfrutar el crecimiento de
                tu hijo, solo estás intentando apagar incendios emocionales.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}